/**
 * @license Copyright (c) Microsoft Corporation.  All rights reserved.
 */
import { PlaceholderUtils } from "./Utilities/PlaceholderUtils";
import { DataSources } from "./Constants/DataSources";
import { PredefinedPlaceholderUtils } from "./Utilities/PredefinedPlaceholderUtils";
var PlaceholderBindingService = /** @class */ (function () {
    function PlaceholderBindingService() {
        this.placeholders = null;
    }
    PlaceholderBindingService.prototype.init = function (placeholdersRaw) {
        if (placeholdersRaw == null) {
            return;
        }
        var parsedPlaceholders = JSON.parse(placeholdersRaw);
        this.placeholders = parsedPlaceholders;
    };
    PlaceholderBindingService.prototype.initWithPlaceholders = function (placeholders) {
        this.placeholders = placeholders;
    };
    PlaceholderBindingService.prototype.setPlaceholder = function (key, placeholder) {
        var _a;
        (_a = window === null || window === void 0 ? void 0 : window.sessionStorage) === null || _a === void 0 ? void 0 : _a.setItem("LastPlaceholderSet", "".concat(Date.now()));
        if (this.placeholders == null) {
            this.placeholders = {};
        }
        this.placeholders[key] = placeholder;
        this.placeholders = PredefinedPlaceholderUtils.removeIdReferencesOnPlaceholderLabelChange(this.placeholders, key, placeholder === null || placeholder === void 0 ? void 0 : placeholder.predefinedPlaceholderId);
    };
    PlaceholderBindingService.prototype.getPlaceholder = function (key) {
        if (this.placeholders == null) {
            return null;
        }
        return this.placeholders[key];
    };
    PlaceholderBindingService.prototype.getPlaceholders = function () {
        return this.placeholders;
    };
    PlaceholderBindingService.prototype.resetBindings = function () {
        if (this.placeholders == null) {
            return;
        }
        for (var placeholderKey in this.placeholders) {
            var placeholder = this.placeholders[placeholderKey];
            var rootBinding = PlaceholderUtils.getRootBinding(placeholder === null || placeholder === void 0 ? void 0 : placeholder.binding);
            if ((rootBinding === null || rootBinding === void 0 ? void 0 : rootBinding.source) === DataSources.LegalDataSource || (rootBinding === null || rootBinding === void 0 ? void 0 : rootBinding.source) === DataSources.BrandDataSource || (rootBinding === null || rootBinding === void 0 ? void 0 : rootBinding.source) === DataSources.DataverseDataSource) {
                continue;
            }
            placeholder.binding = null;
            placeholder.predefinedPlaceholderId = null;
            placeholder.transformation = null;
        }
    };
    PlaceholderBindingService.prototype.getOutputs = function () {
        if (!!this.placeholders) {
            return JSON.stringify(PlaceholderUtils.sortPlaceholders(this.placeholders));
        }
        return null;
    };
    return PlaceholderBindingService;
}());
export { PlaceholderBindingService };
